import { useSetState } from 'ahooks'
import { DatePicker, Picker } from 'antd-mobile'
import { useEffect, useMemo, useCallback } from 'react'

import usePopup from '@/components/NewEditForm/UILibrary/HYBVant/HPopup/hooks/usePopup'
import { DATEPICKER_MAX, DATEPICKER_MIN } from '@/constants'
import useTimeColumn from '@/hooks/useTimeColumn'
import { getTypeof } from '@/utils'
import dayjs from '@/utils/dayjs'

import HCell from '../../HYBVant/HCell'

import './index.less'
import { publicEvents } from '../../HYBVant/utils'

const weekdayToZh = (weekday: number) => {
  switch (weekday) {
    case 1:
      return '周一'
    case 2:
      return '周二'
    case 3:
      return '周三'
    case 4:
      return '周四'
    case 5:
      return '周五'
    case 6:
      return '周六'
    case 7:
      return '周日'
    default:
      return weekday
  }
}
const toDateObj = (date: any) => {
  if (getTypeof(date) === 'Number') {
    return new Date(date)
  }
  if (getTypeof(date) === 'String') {
    return dayjs(date).toDate()
  }
  return date
}
const dateTypeMap: Record<string, string> = {
  year: 'YYYY',
  'year-month': 'YYYY-MM',
  month: 'YYYY-MM',
  date: 'YYYY-MM-DD',
  day: 'YYYY-MM-DD'
}
function DatetimePickerBox(props: any) {
  const { value, type = 'day', onConfirm: _onConfirm, isShowCell = true, ...rest } = props
  const [{ isShow }, setState] = useSetState({
    isShow: false
  })
  const onConfirm = (v: any) => publicEvents.onChange.call(props, v, 'DatePicker')
  const { open, modalData, setModalData, onOpen, onOk, onCancel } = usePopup({
    afterOk: () => {
      // console.log(modalData.value, value, 'modalData.value')
      const __value = modalData.value || value
      onConfirm?.(
        type !== 'time' ? __value || dayjs().format(dateTypeMap[type] || 'YYYY-MM-DD') : __value
      )
      return Promise.resolve()
    }
  })
  const { renderTimeColumn } = useTimeColumn()
  const precision = (type: any) => {
    if (type === 'datetime') {
      return 'minute'
    }
    if (type === 'date') {
      return 'day'
    }
    if (type === 'year-month') {
      return 'month'
    }
    return type
  }
  const labelRenderer = useCallback((str: string, data: number) => {
    switch (str) {
      case 'year':
        return data + '年'
      case 'month':
        return data + '月'
      case 'day':
        return data + '日'
      case 'hour':
        return data + '时'
      case 'minute':
        return data + '分'
      case 'second':
        return data + '秒'
      case 'week':
        return data + '周'
      case 'week-day':
        return weekdayToZh(data)
      default:
        return data
    }
  }, [])
  const { basicColumns } = renderTimeColumn({ ...props, format: 'HH:mm' })
  const onConfirmOk = (timeParts: any) => {
    onConfirm?.(timeParts?.join(':') || null)
  }
  const __value = useMemo(() => {
    return type === 'time' ? modalData?.value : value ? new Date(value) : null
  }, [modalData, value])
  const bool: boolean = !props?.disabled && !props?.readed
  useEffect(() => {
    if (!isShowCell) {
      onOpen(undefined)
    }
  }, [isShowCell])
  return (
    <>
      {isShowCell && (
        <HCell
          value={props.formatter ? props.formatter(value) : value || ''}
          onClick={() =>
            bool &&
            onOpen(
              type === 'time' && getTypeof(value) === 'String'
                ? {
                    value: value.split(':').slice(0, (rest.format || 'HH:mm:ss').split(':').length)
                  }
                : undefined
            )
          }
          disabled={props?.disabled}
          readed={props?.readed}
        />
      )}

      {open && type !== 'time' && (
        <DatePicker
          visible={open}
          className='datetime-picker-context-box'
          precision={precision(type)}
          value={__value}
          onSelect={(e: any) => {
            console.log('setModalData', e, dayjs(e).format('YYYY-MM-DD'))
            setModalData({ value: dayjs(e).format(rest?.format || 'YYYY-MM-DD') })
          }}
          renderLabel={labelRenderer}
          onClose={onCancel}
          onConfirm={onOk}
          min={toDateObj(rest.min || rest.minDate) || DATEPICKER_MIN}
          max={toDateObj(rest.max || rest.maxDate) || DATEPICKER_MAX}
          {...rest}
        />
      )}
      {open && type === 'time' && (
        <Picker
          visible={open}
          className='datetime-picker-context-box'
          columns={basicColumns}
          value={__value}
          onSelect={(e: any) => {
            console.log('picker value:', e)
            setModalData({ value: e })
          }}
          onClose={onCancel}
          onConfirm={onConfirmOk}
        />
      )}
    </>
  )
}

export default DatetimePickerBox
